export default "__VITE_ASSET__15ea6470__"